import { isNewVersion } from 'Components/hooks/use-version'
import { getTabName } from './global-tab'
import decodeUriComponent from 'decode-uri-component'

export const handlePath = (asPath: string) => {
  const search = typeof asPath !== 'undefined' && asPath && asPath.split('?')[1]
  const queries = {} as any
  const initProps = {
    keyword: '',
    currTab: 1,
    city_name: '',
    sort_by: '',
  } as any
  if (search) {
    search.split('&').forEach(function (c: string) {
      if (c === '') {
        return
      }
      const splitArr = c?.split('=')
      const key = splitArr?.[0]
      queries[key] = splitArr?.[1]
    })
    return {
      keyword: decodeUriComponent(queries['keyword'] || ''),
      currTab: Number(queries['currTab'] || 1),
      city_name: decodeURIComponent(queries['city_name'] || ''),
      sort_by:
        Number(queries['sort_by']) > -1 ? Number(queries['sort_by']) : '',
      energy_type: decodeURIComponent(queries['energy_type'] || ''),
      price_range: decodeURIComponent(queries['price_range'] || ''),
      brand_id: decodeURIComponent(queries['brand_id'] || ''),
      from: decodeURIComponent(queries['from'] || ''),
      api_param: decodeURIComponent(queries['api_param'] || ''),
      search_mode: decodeURIComponent(queries['search_mode'] || ''),
    }
  }
  return initProps
}

export const getTypeParams = (str: string | undefined) => {
  return str ? str?.split?.(',')?.[0] : ''
}

// 获取搜索跳转链接
export const getSearchLink = (newParams: {
  [key: string]: string | number
}): {
  link: string
  as: string
} => {
  if (typeof window === 'undefined') {
    return {
      link: isNewVersion() ? '/new_search' : '/search',
      as: '',
    }
  }
  const params: {
    [key: string]: string | number
  } = handlePath(window?.location?.href)

  for (const key of Object.keys(newParams)) {
    if (newParams[key] === 'DELETE_KEY') {
      delete params[key]
    } else {
      params[key] = newParams[key] === undefined ? params[key] : newParams[key]
    }
  }

  // 每次新增一个时间戳
  const list: string[] = []
  Object.keys(params).forEach((key) => {
    if (typeof params[key] === 'string' && params[key]) {
      list.push(`${key}=${params[key]}`)
    }
    if (typeof params[key] === 'number' && params[key] > -1) {
      list.push(`${key}=${params[key]}`)
    }
  })
  const as = `/search${list.length ? '?' : ''}${
    list.length ? list.join('&') : ''
  }`
  return {
    link: isNewVersion() ? '/new_search' : '/search',
    as,
  }
}

// 1440以下场景
// 销量排行榜：强插入feed 第8行-9行之间
// 热搜榜：强插入feed 第16行-17行之间
// 不同tab之下tab 列数不同，插入位置不同
export const fixedCardConfig: {
  [key: string]: any
} = {
  // 综合搜索
  1: {
    bigColumns: 3,
    bigTwGrid: 'tw-col-span-3',
    smallColumns: 4,
    smallTwGrid: 'tw-col-span-4',
    lines: 8,
    // 宽屏
    lgIndex: {
      _cus_fixed_56: 2,
    },
    // 窄屏
    index: {
      _cus_fixed_56: 3,
      _cus_fixed_live_card: 5,
      _cus_fixed_rank_list: 9,
      _cus_fixed_pc_hot_search: 17,
    },
  },
  // 视频
  2: {
    bigColumns: 3,
    bigTwGrid: 'tw-col-span-3',
    smallColumns: 4,
    smallTwGrid: 'tw-col-span-4',
    lines: 8,
    index: {
      _cus_fixed_pc_hot_column: 9,
      _cus_fixed_pc_hot_search: 17,
    },
  },
  // 找车
  6: {
    bigColumns: 5,
    bigTwGrid: 'tw-col-span-5',
    smallColumns: 5,
    smallTwGrid: 'tw-col-span-5',
    lines: 5,
    index: {
      _cus_fixed_live_card: 5,
      _cus_fixed_rank_list: 9,
      _cus_fixed_pc_hot_search: 17,
    },
  },
}
export interface ITeaCommonParams {
  rank: number
  alaSrc: string
  cellType: number
  searchReqId: string
  searchScene: string
  keyword: string
  currTab: number
}
export const makeTeaCommonParams = ({
  rank,
  alaSrc = '',
  cellType = 0,
  searchReqId = '',
  searchScene = '',
  keyword = '',
  currTab = 0,
}: ITeaCommonParams) => {
  return {
    page_id: 'page_search_result_new',
    search_req_id: searchReqId,
    search_scene: searchScene,
    rank: String(rank),
    aladdin: alaSrc,
    cell_type: cellType > 0 ? String(cellType) : '',
    cell_source: cellType > 0 ? `${alaSrc}${cellType}` : '',
    query_content: keyword,
    sub_tab: getTabName(currTab),
  }
}

export const isCusComponent = (cell_type: number | string) => {
  if (cell_type && cell_type?.toString()?.indexOf('_cus_fixed') === 0) {
    return true
  }
  return false
}
